var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardsIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H7C4.2 2 2 4.2 2 7V25C2 27.8 4.2 30 7 30H17C19.8 30 22 27.8 22 25V7C22 4.2 19.8 2 17 2ZM8 9C8 9.6 7.6 10 7 10C6.4 10 6 9.6 6 9V7C6 6.4 6.4 6 7 6C7.6 6 8 6.4 8 7V9ZM15.3 17.3C14.9 17.7 14.3 18 13.7 18C13.5 18 13.2 18 13 17.9V19C13.6 19 14 19.4 14 20C14 20.6 13.6 21 13 21H11C10.4 21 10 20.6 10 20C10 19.4 10.4 19 11 19V17.9C10.8 18 10.5 18 10.3 18C9.7 18 9.1 17.8 8.7 17.3C7.8 16.4 7.8 14.9 8.7 14L11.3 11.3C11.7 10.9 12.4 10.9 12.7 11.3L15.3 14C16.2 14.9 16.2 16.4 15.3 17.3ZM18 25C18 25.6 17.6 26 17 26C16.4 26 16 25.6 16 25V23C16 22.4 16.4 22 17 22C17.6 22 18 22.4 18 23V25Z",
    fill: "#FDA94A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 8.59999L24 5.89999V25.8L30.2 15.5C31.6 13.1 30.9 9.99999 28.5 8.59999Z",
    fill: "#FDA94A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsIconOrange);
export default __webpack_public_path__ + "static/media/cards-icon-orange.c6f256d564e7261225264903b3c2ed42.svg";
export { ForwardRef as ReactComponent };